// v6 F14 §4 — Curated country list voor de klant-landkeuze.
// ISO-3166-1 alpha-2 codes + Nederlandse landnamen.
// Sorteervolgorde in UI = alfabetisch op Nederlandse naam (localeCompare "nl").
// COMMON_CODES verschijnen bovenaan de picker als "Veelgebruikt" voor snelle
// selectie in de BeNeLux + directe buurlanden.

export const COUNTRIES = [
  { code: "BE", label: "België" },
  { code: "NL", label: "Nederland" },
  { code: "FR", label: "Frankrijk" },
  { code: "DE", label: "Duitsland" },
  { code: "LU", label: "Luxemburg" },
  { code: "ES", label: "Spanje" },
  { code: "IT", label: "Italië" },
  { code: "PT", label: "Portugal" },
  { code: "AT", label: "Oostenrijk" },
  { code: "CH", label: "Zwitserland" },
  { code: "GB", label: "Verenigd Koninkrijk" },
  { code: "IE", label: "Ierland" },
  { code: "DK", label: "Denemarken" },
  { code: "SE", label: "Zweden" },
  { code: "NO", label: "Noorwegen" },
  { code: "FI", label: "Finland" },
  { code: "PL", label: "Polen" },
  { code: "CZ", label: "Tsjechië" },
  { code: "SK", label: "Slowakije" },
  { code: "HU", label: "Hongarije" },
  { code: "RO", label: "Roemenië" },
  { code: "BG", label: "Bulgarije" },
  { code: "GR", label: "Griekenland" },
  { code: "HR", label: "Kroatië" },
  { code: "SI", label: "Slovenië" },
  { code: "EE", label: "Estland" },
  { code: "LV", label: "Letland" },
  { code: "LT", label: "Litouwen" },
  { code: "CY", label: "Cyprus" },
  { code: "MT", label: "Malta" },
  { code: "IS", label: "IJsland" },
  { code: "MC", label: "Monaco" },
  { code: "AD", label: "Andorra" },
  { code: "LI", label: "Liechtenstein" },
  { code: "SM", label: "San Marino" },
  { code: "MA", label: "Marokko" },
  { code: "TR", label: "Turkije" },
  { code: "US", label: "Verenigde Staten" },
  { code: "CA", label: "Canada" },
];

export const COMMON_CODES = ["BE", "NL", "FR", "DE", "LU"];

export const COUNTRY_LABEL = COUNTRIES.reduce((acc, c) => {
  acc[c.code] = c.label;
  return acc;
}, {});

export function countryLabel(code) {
  if (!code) return "";
  return COUNTRY_LABEL[String(code).toUpperCase()] || String(code).toUpperCase();
}
